import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ILogin } from "../../models/Login";
import { Button } from "primereact/button";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { useEffect, useState } from "react";
import { IBranchMastDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown, ITeamsDropdown, IUsersDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { ITeamMemberSkillMast, ITeamSkillMast } from "../../models/ISkillTeamManagement";

export const EmptySkillFilter: ITeamMemberSkillMast = {
    company_ID: null,
    branch_ID: null,
    req_CategoryID: null,
    team_ID: null,
    teamManagerid: null,
}

interface IFilterProps {
    skillFilter: ITeamMemberSkillMast,
    setSkillFilter: (skillFilter: ITeamMemberSkillMast) => void,
}

const schema = yup.object({
    // fromDate: yup.date().nullable(),
    // toDate: yup.date().nullable(),
    company_ID: yup.number().nullable(),
    branch_ID: yup.number().nullable(),
    req_CategoryID: yup.number().nullable(),
    teamManagerid:yup.number().nullable(),
});

export const Filter = (props: IFilterProps) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();



    const { control, handleSubmit, reset, watch } = useForm<ITeamMemberSkillMast>({
        defaultValues: props.skillFilter,
        resolver: yupResolver(schema),
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    };

    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList" ;
        
        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    };

    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList" ;

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    };

    const loadTeam = async (branch: number | null | undefined, company: number | null | undefined, type?: string) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }

        const response = await Fetch("Dropdown/filterTeamsList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }

    const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }

    const searchToDB = async (body: ITeamMemberSkillMast) => {
        let filterData: any = body;
        let emptyFilter: any = EmptySkillFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setSkillFilter(body);
    }

    const onSubmit = (data: ITeamMemberSkillMast) => {
        searchToDB(data);
    };

    const Clear = () => {
        reset(EmptySkillFilter);
        loadSm(0, 0, 0);
        loadTeam(0, 0, "");
        loadBranches();
        loadCompanies();
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company_ID") {
                if (value.company_ID != 0 && value.company_ID != null) {
                    loadTeam(0, value.company_ID);
                    loadSm(0, value.company_ID, 0);
                    loadBranches(value.company_ID);
                } else {
                    if (value.company_ID === 0 && value.company_ID != null) {
                        loadBranches();
                        loadTeam(control._formValues.branch_ID, value.company_ID);
                        loadSm(control._formValues.branch_ID, value.company_ID, control._formValues.team_ID);
                    }
                }
            }

            if (name === "branch_ID") {
                if (value.branch_ID != 0 && value.branch_ID != null) {
                    loadTeam(value.branch_ID, 0);
                    loadSm(value.branch_ID, 0, 0);
                } else {
                    if (value.branch_ID === 0 && value.branch_ID != null) {
                        loadTeam(value.branch_ID, control._formValues.company_ID);
                        loadSm(value.branch_ID, control._formValues.company_ID, control._formValues.team_ID);
                    }
                }
            }

            if (name === "team_ID") {
                if (value.team_ID != 0 && value.team_ID != null) {
                    loadSm(0, 0, value.team_ID);
                } else {
                    if (value.team_ID === 0 && value.team_ID != null) {
                        loadSm(control._formValues.branch_ID, control._formValues.company_ID, value.team_ID);
                    }
                }
            }

            

        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadTeam(0, 0);
        loadSm(0, 0, 0);
        loadCompanies();
        loadBranches();
        loadSkillCategories();
    }, []);



    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDropdown column={6} label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <JVDropdown column={6} label="Branch" control={control} name="branch_ID" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
            <JVDropdown column={6} label="Req Category" control={control} name="req_CategoryID" options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Req Category" />
            <JVDropdown column={6} label="Team" control={control} name="teamManagerid" options={team} optionLabel="team_Name" optionValue="teamManagerid" placeholder="Select Team" />
            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={Clear} type="button"></Button>
            </div>
        </form>
    );
}